module.exports = __webpack_public_path__ + "static/funnels4-ec9681a487046166f87593823f79decd.png";